import React, { createContext, useEffect, useState } from 'react';

export const LayoutContext = createContext();

export const LayoutContextProvider = ({ children }) => {
  const pMql = window.matchMedia(
    'screen and (max-width: 450px) and (orientation: portrait), screen and (max-height: 414px) and (orientation: landscape)'
  );
  const tMql = window.matchMedia(
    'screen and (min-width: 451px) and (max-width: 800px) and (orientation: portrait), screen and (min-width: 700px) and (max-width: 1023px) and (orientation: landscape)'
  );

  const [phoneActive, setPhoneActive] = useState(pMql.matches);
  const [tabletActive, setTabletActive] = useState(tMql.matches);

  useEffect(() => {
    pMql.addEventListener('change', (e) => setPhoneActive(e.matches));
    tMql.addEventListener('change', (e) => setTabletActive(e.matches));

    return () => {
      pMql.removeEventListener('change', (e) => setPhoneActive(e.matches));
      tMql.removeEventListener('change', (e) => setTabletActive(e.matches));
    };
  }, []); // eslint-disable-line

  return (
    <LayoutContext.Provider value={{ phoneActive, tabletActive }}>
      {children}
    </LayoutContext.Provider>
  );
};
